
import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const TeacherNotFoundState = () => {
  const navigate = useNavigate();
  
  return (
    <div className="container mx-auto px-4 py-8">
      <Card className="p-6">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Teacher Not Found</h2>
          <p className="text-gray-600 mb-6">The teacher you're looking for does not exist or has been removed.</p>
          <Button onClick={() => navigate("/teachers")}>
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Teachers
          </Button>
        </div>
      </Card>
    </div>
  );
};
